import { Dispatch, useContext } from 'react'

import { DispatchContext, WorkspaceStore } from './workspace.provider'
import { WorkspaceState } from './workspace.type'

export function useWorkspaceContext(): [
  WorkspaceState,
  Dispatch<{
    type: string
  }>,
] {
  const ctx = useContext(WorkspaceStore)
  const dispatch = useContext(DispatchContext)
  return [ctx, dispatch]
}
